import type { MessageHandlerDeps } from '../../message-handler-deps.js';
import { parseWorkingTreeChangeKind } from '../../../worktrees/manager/git/index.js';
import { parseSessionGitChangesParams } from './session-git-changes-params.js';

type SessionGitReply = (payload: Record<string, unknown>, encryptedFields?: readonly string[]) => void;

export async function handleSessionGitGetChangeFilePatchAction(
  deps: MessageHandlerDeps,
  msg: { sessionId: string } & Record<string, unknown>,
  reply: SessionGitReply,
): Promise<void> {
  const changes = parseSessionGitChangesParams(msg);
  const { repoRelPath: repoRel, view, commitSha, fileWorkspaceRelPath, fileChange, fileMovedFromWorkspaceRelPath } =
    changes;
  const change = parseWorkingTreeChangeKind(fileChange);

  if (!repoRel || !fileWorkspaceRelPath || !change) {
    reply({
      ok: false,
      error: 'changes.repoRelPath, changes.file.workspaceRelPath, and changes.file.change are required',
    });
    return;
  }
  if (view === 'commit' && !commitSha) {
    reply({ ok: false, error: 'changes.commitSha is required for commit file patch' });
    return;
  }

  const patch = await deps.sessionWorktreeManager.getSessionWorkingTreeChangeFilePatch(msg.sessionId, {
    repoRelPath: repoRel,
    workspaceRelPath: fileWorkspaceRelPath,
    change,
    movedFromWorkspaceRelPath: fileMovedFromWorkspaceRelPath || null,
    basis: view === 'commit' ? { kind: 'commit', sha: commitSha } : { kind: 'working' },
  });
  reply(
    {
      ok: true,
      patchContent: patch.patchContent ?? null,
      totalLines: patch.totalLines,
    },
    ['patchContent'],
  );
}
